import { ReactElement, useEffect } from 'react';
import { NullableNumber, NullableString } from '@app/common/types';
import useOrdersFilters from '../filterBar/useOrdersFilters';
import ConfirmedTable from './ordersTable/confirmedTable';
import NoRecords from './ordersTable/noRecords';
import OrderedTable from './ordersTable/orderedTable';
import PendingTable from './ordersTable/pendingTable';
import TestedTable from './ordersTable/testedTable';
import { OrdersStateTypes } from './types';
import useFetchOrders from './useFetchOrders';
import useOrdersData from './useOrdersData';

export type GenericOrderTable = {
  onOrderClick: (id: NullableNumber | NullableString) => void;
};

type OrdersTypeTableI = {
  ordersType: OrdersStateTypes;
  setSelectedOrderId: (id: NullableNumber | NullableString) => void;
};

const OrdersTypeTable = ({
  ordersType,
  setSelectedOrderId,
}: OrdersTypeTableI): ReactElement => {
  const loadOrders = useFetchOrders(false);
  const { filters } = useOrdersFilters();
  const { totalCount } = useOrdersData();

  useEffect(() => {
    loadOrders();
  }, [loadOrders, filters.ordersState]);

  if (totalCount === 0) {
    return <NoRecords />;
  }

  switch (ordersType) {
    case 'confirmed':
      return <ConfirmedTable onOrderClick={setSelectedOrderId} />;
    case 'pending':
      return <PendingTable onOrderClick={setSelectedOrderId} />;
    case 'done':
      return <TestedTable onOrderClick={setSelectedOrderId} />;
    case 'ordered':
    default:
      return <OrderedTable onOrderClick={setSelectedOrderId} />;
  }
};

export default OrdersTypeTable;
